module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-heart-9dc4f836f1fc076c3a9413aac581d8e2.png";